import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPaymentMethodList(params) {
  return request({
    url: URL.mdm.basicData.paymentMethod,
    method: 'get',
    params
  })
}

export function savePaymentMethod(data) {
  return request({
    url: URL.mdm.basicData.paymentMethod,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function deletePaymentMethod(data) {
  return request({
    url: URL.mdm.basicData.paymentMethod,
    method: 'delete',
    data
  })
}
